import styled, { css } from "styled-components";

const buttonResetStyles = css`
    background: transparent;
    border: none;
    outline: none;
    padding: 0;
    text-align: left;
    appearance: none;
    -webkit-appearance: none;
`;

export const MenuButton = styled.button`
    ${buttonResetStyles}
    position: relative;
    margin-top: ${(props) => props.theme.spacing.xxxSmall};
    align-self: flex-start;
    margin-left: ${(props) => props.theme.spacing.xSmall};
    z-index: 400;

    /* Increase touch area  */
    &::before {
        content: "";
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 44px;
        height: 44px;
    }
`;

export const Menu = styled.div<{ show?: boolean; isIncognitoCart?: boolean; isLottieAnimation: boolean }>(
    ({ theme, show, isIncognitoCart, isLottieAnimation }) => {
        const topSpacing = isIncognitoCart ? "60px" : "36px";
        return {
            backgroundColor: theme.colors[theme.colorMode].background_inverse_Primary,
            borderRadius: theme.cornerRadius.medium,
            color: theme.colors[theme.colorMode].text_inverse_Highest_Emphasis,
            padding: theme.spacing.small,
            position: "absolute",
            top: topSpacing,
            right: "14px",
            display: show ? "flex" : "none",
            zIndex: 3,
            alignItems: "center",
            "@supports (top: var(--sat))": {
                top: isLottieAnimation ? "36px" : `calc(var(--sat, 0px) + ${topSpacing})`,
            },
        };
    },
);

export const Overlay = styled.div<{ show?: boolean }>`
    background-color: transparent;
    display: ${({ show }) => (show ? "block" : "none")};
    z-index: 2;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    backface-visibility: hidden;
    opacity: 0;
`;

export const MenuTooltipIconStyled = styled.span`
    position: relative;
    top: 1px;
    margin-right: ${({ theme }) => theme.spacing.xSmall};
`;
